import { AirTimeManagementImpl } from "features/airTimeManagement/data/AirtimeManagementImpl";
import { IAirTimeManagementRepository } from "features/airTimeManagement/domain/repositories/IAirtimeManagementRepository";
import { AirtimeManagementUseCase } from "features/airTimeManagement/domain/useCases/AirtimeManagementUseCase";
import { AirTimeManagementViewModel } from "features/airTimeManagement/presentation/viewModel/AirTimeManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class AirtimeManagementInjection extends InjectionModule {
  private static readonly airTimeManagementRepositoryToken = Symbol(
    "IAirTimeManagementRepository",
  );
  private static readonly airTimeManagementViewModelToken = Symbol(
    "AirTimeManagementViewModel",
  );
  private static readonly airtimeManagementUseCaseToken = Symbol(
    "AirtimeManagementUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.airTimeManagementRepositoryToken,
      useClass: AirTimeManagementImpl,
    },
    {
      scope: "otherRepo",
      token: this.airtimeManagementUseCaseToken,
      useClass: AirtimeManagementUseCase,
    },
    {
      scope: "viewModel",
      token: this.airTimeManagementViewModelToken,
      useClass: AirTimeManagementViewModel,
    },
  ];

  static getAirtimeManagementRepo(): IAirTimeManagementRepository {
    return this.resolve(this.airTimeManagementRepositoryToken);
  }

  static getAirtimeManagementUseCase(): AirtimeManagementUseCase {
    return this.resolve(this.airtimeManagementUseCaseToken);
  }
}
